<h2 class="nordic-blue-900-text" [ngClass]="headingClasses" *ngIf="showHeading">
  {{ titleTranslationKey | finLocalization }}
</h2>

<div
  class="mr-small-t white-bg rounded-large border pr-small"
  *ngIf="headerContents$ | async as contents"
  data-testid="included-products-header-contents"
>
  <div *ngFor="let item of contents; let first = first; let isLast = last" [class.mr-small-t]="!first">
    <p>
      {{ item }}
    </p>
  </div>
</div>

<div class="bound-products pr-xsmall-t">
  <fcom-tabs
    [theme]="TabTheme.CLASSIC"
    [layoutType]="TabLayoutType.STRETCH"
    [prevButtonAriaLabel]="'carousel.previous' | finLocalization"
    [nextButtonAriaLabel]="'carousel.next' | finLocalization"
    [tabStyleOverrideClasses]="'pr-small'"
  >
    <div class="white-bg rounded-bottom-large border-bottom border-left border-right">
      <fcom-tab
        [title]="
          booking.locations[boundWithServices.departure.locationCode]?.cityName +
          ' - ' +
          booking.locations[boundWithServices.arrival.locationCode]?.cityName
        "
        *ngFor="let boundWithServices of servicesForBounds"
      >
        <div class="pr-small" *ngIf="boundWithServices.services.length === 0">
          <fcom-notification>{{ 'MMB.includedProducts.noServicesTitle' | finLocalization }}</fcom-notification>
        </div>
        <ng-container *ngFor="let service of boundWithServices.services; first as isFirstService">
          <div class="pr-xxsmall-b" [ngClass]="{ 'border-top': !isFirstService }">
            <fin-included-product-item
              [attr.data-testid]="'ancillary-category-' + service.category"
              [category]="service.category"
              [buttonTranslationKey]="'MMB.includedProducts.' + service.category + '.title'"
              [additionalTitle]="
                showAdditionalTitle
                  ? ('purchase.review.ancillarySelection'
                    | finLocalization
                      : { amount: service.bounds[0]?.quantity, price: service.bounds[0]?.totalPrice | finPrice })
                  : ''
              "
              [passengers]="booking.passengers"
              [bound]="boundWithServices"
              [service]="service"
              [expandOpen]="service.upsell?.expand || expandOpen"
              [isShortHaulFlight]="isShortHaulFlight"
              [displaySeatReassignMessage]="
                displaySeatReassignMessage && isFirstService && service.category === Category.SEAT
              "
            >
              <fin-dapi-included-service
                *ngIf="!service.upsell?.enabled"
                [service]="service"
                [products$]="products$"
                [showAsPending]="showAsPending"
                [cartOrOrder$]="booking | finToObservable"
                [passengers$]="booking.passengers | finToObservable"
                [showUpsellPerPax]="showUpsell"
                [includeSeatActionButtons]="includeSeatActionButtons"
                [showClearPendingSeatsButton]="showClearPendingSeatsButton"
                [isCarrierConnect]="isCarrierConnect"
                [includeAssignAtAirportStatus]="includeAssignAtAirportStatus"
                [showNonAYSeats]="showNonAYSeats"
                [removeProgressInfo$]="removeInProgress$"
                [groupServicesByBound]="groupServicesByBound"
                [isShoppingCart]="isShoppingCart"
                (selectProduct)="onSelectProduct($event)"
                (continuePurchase)="onContinuePurchase()"
                (removeProduct)="onRemoveProduct($event, boundWithServices.id)"
                (clearPendingSeats)="clearPendingSeats.emit()"
                (viewSeatmap)="viewSeatmap.emit()"
              ></fin-dapi-included-service>

              <fin-upsell-card
                [attr.data-testid]="'category-upsell-' + service.category"
                *ngIf="showUpsell && service.upsell?.enabled"
                [boundWithServices]="boundWithServices"
                [service]="service"
                (upsellClicked)="onSelectProduct({ category: service.category, fragmentId: boundWithServices.id })"
              ></fin-upsell-card>

              <fin-information-modal
                *ngIf="showInformationModal"
                [category]="service.category"
                [upsell]="(upsellInModal$ | async)?.[boundWithServices.id]?.[service.category] ?? false"
                (upsellClicked)="onSelectProduct({ category: service.category, fragmentId: boundWithServices.id })"
              ></fin-information-modal>

              <div
                *ngIf="service.upsell?.isShowMoreBtn && (service.upsell?.updatingService$ | async) !== true"
                class="border-top ms-xsmall-t nordic-blue-100-border flex flex--row-reverse"
              >
                <fcom-button
                  *ngIf="service.category !== Category.SPECIAL_NEED"
                  class="block pr-xxsmall-t align-right"
                  (click)="onSelectProduct({ category: service.category, fragmentId: boundWithServices.id })"
                  [icon]="{
                    name: SvgLibraryIcon.PLUS,
                    position: IconPosition.RIGHT,
                  }"
                  [theme]="ButtonTheme.LIGHT_PRIMARY_NORDIC_BLUE"
                  [size]="ButtonSize.MEDIUM"
                  [mode]="ButtonMode.FILL_MOBILE"
                  [text]="'actions.addMore' | finLocalization"
                ></fcom-button>

                <fcom-button
                  *ngIf="service.category === Category.SPECIAL_NEED"
                  class="block pr-xxsmall-t align-right"
                  [href]="'MMB.links.specialAssistance.url' | finLocalization"
                  [icon]="{
                    name: SvgLibraryIcon.EXTERNAL_TAB,
                    position: IconPosition.RIGHT,
                  }"
                  [openInNewTab]="true"
                  [theme]="ButtonTheme.LIGHT_SECONDARY_OUTLINE"
                  [size]="ButtonSize.MEDIUM"
                  [mode]="ButtonMode.FILL_MOBILE"
                  [text]="'actions.assistance' | finLocalization"
                ></fcom-button>
              </div>

              <fcom-button
                class="block pr-small-t align-right flex--self-end"
                *ngIf="showModifyButtons && !isShoppingCart"
                (clickBtn)="onSelectProduct({ category: service.category, fragmentId: boundWithServices.id })"
                [theme]="ButtonTheme.LIGHT_SECONDARY_OUTLINE"
                [mode]="ButtonMode.FILL_MOBILE"
                [text]="'actions.modify' | finLocalization"
              ></fcom-button>
            </fin-included-product-item>
          </div>
        </ng-container>

        <div *ngIf="showTickets" class="pr-small-b" [class.border-top]="servicesToShow.length > 0">
          <fin-included-product-item
            data-testid="category-tickets"
            category="tickets"
            buttonTranslationKey="MMB.includedProducts.tickets.title"
            additionalTitle=""
          >
            <fin-included-tickets
              [locations]="booking.locations"
              [bound]="boundWithServices"
              [useCabinClass]="useCabinClass"
            ></fin-included-tickets>
          </fin-included-product-item>
        </div>
      </fcom-tab>
    </div>
  </fcom-tabs>
</div>
